import { Component, OnInit } from '@angular/core';
import { CartBill, CartFees } from '@cargos/sprintpay-models';
import { Breadcrumbs } from 'src/app/shared/components/breadcrumbs/models';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/services/breadcrumbs.service';
import { FeesConfiguration } from 'src/app/shared/modules/cart/lib-cart/shared/models/convenience-fee.enum';
import { ConfigService, CurrentFacilityService } from 'src/app/shared/services';
import { EWRFees } from './models/dhl-ewr-fees';

@Component({
    selector: 'app-cart-dhl',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false,
})
export class CartDHLComponent implements OnInit {
    public emptyCartMessage = '';
    private awbLabel: string;

    public convenienceFees: FeesConfiguration[] = [
        {
            feeName: CartFees.ISC_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.ISC_FEE),
            feeValue: 0,
        },
        {
            feeName: CartFees.NON_ISC_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.NON_ISC_FEE),
            feeValue: 0,
        },
        {
            feeName: CartFees.CUSTOMS_FEE,
            feeLabel: '',
            feeValue: 0,
            feeInfoTooltip: '',
            getFeeInfoTooltip: (name) => {
                switch (name) {
                    case EWRFees.EXAM_FEE:
                        return 'Fee is only applicable to EWR airport only. Fee is collected for exam facility as pass-through charge.';
                    case EWRFees.PORT_FEE:
                        return 'JFK Port Authority 5.263 %';
                    default:
                        return '';
                }
            },
        },
        {
            feeName: CartFees.CREDIT_CARD_FEE_TOTAL,
            feeLabel: CartBill.getFeeDescription(CartFees.CREDIT_CARD_FEE_TOTAL),
            feeValue: 0,
            extraFee: true,
        },
        {
            feeName: CartFees.HANDLING_FEE_TOTAL,
            feeLabel: CartBill.getFeeDescription(CartFees.HANDLING_FEE_TOTAL),
            feeValue: 0,
            extraFee: true,
        },
    ];

    constructor(
        private breadcrumbsService: BreadcrumbsService,
        private currentFacilityService: CurrentFacilityService,
        private configService: ConfigService
    ) {}

    ngOnInit(): void {
        this.getConfig();
        this.updateBreadcrumbs();
    }

    updateBreadcrumbs(): void {
        const breadcrumbs = this.reviewPreviousPage();

        this.breadcrumbsService.sendMessage(breadcrumbs);
    }

    reviewPreviousPage(): Breadcrumbs[] {
        let previusCart: Breadcrumbs[];

        previusCart = [
            { section: 'HOME', link: '/', class: '' },
            {
                section: `SEARCH ${this.awbLabel}`,
                link: '/search-awb',
                class: '',
            },
            {
                section: 'CHARGES',
                link: '/search-awb/details/charges',
                class: '',
            },
            {
                section: 'CART',
                link: '/cart',
                class: 'active',
            },
        ];

        this.emptyCartMessage = 'To make a new payment, you must first search by MAWB and select charges.';

        return previusCart;
    }

    getConfig(): void {
        this.awbLabel = this.configService.getLabelAWB();
    }
}
